import type { ApplicationStatus } from "../api/types";

const STYLES: Record<ApplicationStatus, string> = {
  reviewing: "bg-gray-100 text-gray-700",
  applied: "bg-blue-50 text-blue-700",
  screening: "bg-indigo-50 text-indigo-700",
  interviewing: "bg-amber-50 text-amber-700",
  offer: "bg-accent-50 text-accent-700",
  rejected: "bg-red-50 text-red-700",
  withdrawn: "bg-gray-100 text-gray-500",
};

const LABELS: Record<ApplicationStatus, string> = {
  reviewing: "Reviewing",
  applied: "Applied",
  screening: "Screening",
  interviewing: "Interviewing",
  offer: "Offer",
  rejected: "Rejected",
  withdrawn: "Withdrawn",
};

export default function StatusBadge({ status }: { status: ApplicationStatus }) {
  return (
    <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${STYLES[status]}`}>
      {LABELS[status]}
    </span>
  );
}

export { LABELS as STATUS_LABELS };
